import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

import { IsUsedInItemEntity } from '.'

export enum ProductTypeSearchFields {
	searchResultById = 'searchResultById',
	searchResultByName = 'searchResultByName',
	searchResultByCategoryName = 'searchResultByCategoryName'
}

export enum ProductTypeFilterFields {
	includeInactive = 'includeInactive'
}

export declare namespace ProductType {
	interface Basic extends Entity {
		productCategory: string | null
		isActive: boolean
	}

	interface Detailed extends Omit<Basic, 'productCategory'> {
		productCategory: IsUsedInItemEntity | null
	}

	namespace Form {
		interface Generic {
			name: string
			productCategoryId: number | null
			isActive: boolean
		}
	}

	namespace Request {
		interface Generic {
			name: string
			productCategoryId: number
			isActive: boolean
		}
	}

	namespace Search {
		interface Result {
			[ProductTypeSearchFields.searchResultById]: Entity[]
			[ProductTypeSearchFields.searchResultByName]: Entity[]
			[ProductTypeSearchFields.searchResultByCategoryName]: Entity[]
		}

		interface Config {
			[ProductTypeSearchFields.searchResultById]: ConfigItem<ProductTypeSearchFields>
			[ProductTypeSearchFields.searchResultByName]: ConfigItem<ProductTypeSearchFields>
			[ProductTypeSearchFields.searchResultByCategoryName]: ConfigItem<ProductTypeSearchFields>
		}
	}

	namespace Filters {
		interface Config {
			[ProductTypeFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
		}
	}
}
